/**
 * shop-product (React) — l'essentiel du design vient de shop-forms.css /
 * shop-cart.css (enqueued globalement, classes .gas-shop-* réutilisées à
 * l'identique). On coupe seulement les animations Radix du dialog de confirmation
 * (useGasConfirm) qui sont gênantes en usage métier.
 */
.gas-react-dialog__overlay,
.gas-react-dialog__content,
.gas-react-dialog__content *,
[data-radix-popper-content-wrapper],
[data-radix-popper-content-wrapper] *,
[data-radix-portal],
[data-radix-portal] * {
    animation: none !important;
    animation-duration: 0s !important;
    animation-delay: 0s !important;
    transition: none !important;
    transition-duration: 0s !important;
    transition-delay: 0s !important;
}

.gas-shop-product-messages {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-s);
}

/* ─────────────────────────────────────────────────────────────────────────
 * Paiement conscient (Name Your Price) — sélecteur de montant affiché à la place du prix
 * fixe quand price_mode === 'name_your_price'. Le serveur re-borne toujours le montant.
 * ───────────────────────────────────────────────────────────────────────── */
.gas-shop-name-your-price {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-s);
    padding: var(--gas-space-m);
    margin-bottom: var(--gas-space-m);
    background: var(--gas-bg-surface-subtle);
    border: 1px solid var(--gas-border-color-light);
    border-radius: var(--gas-radius-m);
}

.gas-shop-name-your-price__title {
    margin: 0;
    font-size: var(--gas-text-m);
    font-weight: var(--gas-weight-semi);
    color: var(--gas-text-color);
}

.gas-shop-name-your-price__hint {
    margin: 0;
    font-size: var(--gas-text-s);
    color: var(--gas-text-color-light);
}

.gas-shop-name-your-price__presets {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-xs);
}

.gas-shop-name-your-price__preset {
    padding: var(--gas-space-xs) var(--gas-space-m);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-medium);
    color: var(--gas-color-primary);
    background: var(--gas-bg-surface);
    border: 1px solid var(--gas-color-primary);
    border-radius: var(--gas-radius-pill);
    cursor: pointer;
}

.gas-shop-name-your-price__preset:hover {
    background: var(--gas-color-primary-soft);
}

.gas-shop-name-your-price__preset--active {
    color: var(--gas-color-primary-fg);
    background: var(--gas-color-primary);
    border-color: var(--gas-color-primary);
}

.gas-shop-name-your-price__custom {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-xs);
}

.gas-shop-name-your-price__label {
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-medium);
    color: var(--gas-text-color);
}

.gas-shop-name-your-price__input-wrap {
    display: flex;
    align-items: center;
    gap: var(--gas-space-xs);
    max-width: 180px;
}

.gas-shop-name-your-price__input {
    flex: 1 1 auto;
    min-width: 0;
    padding: var(--gas-space-xs) var(--gas-space-s);
    font-size: var(--gas-text-m);
    color: var(--gas-text-color);
    background: var(--gas-bg-surface);
    border: 1px solid var(--gas-border-color);
    border-radius: var(--gas-radius-control);
}

.gas-shop-name-your-price__input:focus {
    outline: none;
    border-color: var(--gas-color-primary);
    box-shadow: 0 0 0 2px var(--gas-color-primary-ring);
}

.gas-shop-name-your-price__currency {
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-semi);
    color: var(--gas-text-color-light);
}

/* ─────────────────────────────────────────────────────────────────────────
 * M6 — Buy-box multi-variantes physiques (axes / anti-aplat / réassort)
 * ───────────────────────────────────────────────────────────────────────── */
.gas-shop-physical-buybox {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-m);
}

.gas-shop-physical-buybox__image-wrap {
    max-width: 320px;
    border-radius: var(--gas-radius-m);
    overflow: hidden;
    background: var(--gas-bg-surface-subtle);
}

.gas-shop-physical-buybox__thumbs {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-2, 8px);
    margin-top: var(--gas-space-2, 8px);
}

.gas-shop-physical-buybox__thumb {
    display: block;
    padding: 0;
    border: 2px solid transparent;
    border-radius: var(--gas-radius-sm, 4px);
    background: transparent;
    cursor: pointer;
    overflow: hidden;
    width: 56px;
    height: 56px;
}

.gas-shop-physical-buybox__thumb.is-active {
    border-color: var(--gas-color-primary, #2563eb);
}

.gas-shop-physical-buybox__thumb img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.gas-shop-physical-buybox__image {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
}

.gas-shop-physical-buybox__intro {
    margin: 0;
    font-size: var(--gas-text-s);
    color: var(--gas-text-color-light);
}

.gas-shop-physical-buybox__axis {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-xs);
}

.gas-shop-physical-buybox__axis-label {
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-semi);
    color: var(--gas-text-color);
}

.gas-shop-physical-buybox__pills {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-xs);
}

.gas-shop-physical-buybox__pill {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: var(--gas-space-xs) var(--gas-space-m);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-medium);
    color: var(--gas-text-color);
    background: var(--gas-bg-surface);
    border: 1px solid var(--gas-border-color);
    border-radius: var(--gas-radius-pill);
    cursor: pointer;
}

.gas-shop-physical-buybox__pill:hover:not(:disabled) {
    border-color: var(--gas-color-primary);
    color: var(--gas-color-primary);
}

.gas-shop-physical-buybox__pill--selected {
    color: var(--gas-color-primary-fg, #fff);
    background: var(--gas-color-primary);
    border-color: var(--gas-color-primary);
}

.gas-shop-physical-buybox__pill--sold-out {
    opacity: 0.55;
    text-decoration: line-through;
}

.gas-shop-physical-buybox__pill--missing {
    opacity: 0.4;
    cursor: not-allowed;
    border-style: dashed;
}

.gas-shop-physical-buybox__pill-hint {
    font-size: 10px;
    font-weight: var(--gas-weight-regular);
    text-decoration: none;
    line-height: 1.2;
}

.gas-shop-physical-buybox__price {
    display: flex;
    align-items: center;
    gap: var(--gas-space-s);
    font-size: var(--gas-text-l);
}

.gas-shop-physical-buybox__bucket {
    font-size: var(--gas-text-xs);
    font-weight: var(--gas-weight-medium);
    padding: 2px 8px;
    border-radius: var(--gas-radius-pill);
    background: var(--gas-bg-surface-subtle);
}

.gas-shop-physical-buybox__bucket--unavailable {
    color: var(--gas-color-danger, #b91c1c);
    background: color-mix(in srgb, var(--gas-color-danger, #b91c1c) 12%, transparent);
}

.gas-shop-physical-buybox__bucket--low_stock,
.gas-shop-physical-buybox__bucket--backorder {
    color: var(--gas-color-warning, #b45309);
}

.gas-shop-physical-buybox__status {
    margin: 0;
    font-size: var(--gas-text-s);
}

.gas-shop-physical-buybox__status--missing,
.gas-shop-physical-buybox__status--sold-out {
    color: var(--gas-color-danger, #b91c1c);
}

.gas-shop-physical-buybox__hint {
    margin: 0;
    font-size: var(--gas-text-s);
    color: var(--gas-text-color-light);
}

.gas-shop-physical-buybox__restock {
    margin-top: var(--gas-space-s);
    padding: var(--gas-space-m);
    border: 1px solid var(--gas-border-color-light);
    border-radius: var(--gas-radius-m);
    background: var(--gas-bg-surface-subtle);
}
